"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const common_types_1 = require("../../common-types");
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../composite/table/table-cells");
const table_filter_cells_1 = require("../../composite/table/table-filter-cells");
const notification_api_1 = require("./notification-api");
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    return [
        {
            datakey: 'event',
            sortkey: 'event.name',
            filterkey: 'event.id',
            name: intl.formatMessage({
                id: 'EAS_NOTIFICATIONS_COLUMN_EVENT',
                defaultMessage: 'Událost',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(notification_api_1.useNotificationEvents),
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(notification_api_1.useNotificationEvents),
            filterOperation: common_types_1.ApiFilterOperation.EQ,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'type',
            sortkey: 'type.name',
            filterkey: 'type.id',
            name: intl.formatMessage({
                id: 'EAS_NOTIFICATIONS_COLUMN_TYPE',
                defaultMessage: 'Typ notifikace',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(notification_api_1.useNotificationTypes),
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(notification_api_1.useNotificationTypes),
            filterOperation: common_types_1.ApiFilterOperation.EQ,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'subject',
            name: intl.formatMessage({
                id: 'EAS_NOTIFICATIONS_COLUMN_SUBJECT',
                defaultMessage: 'Předmět',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: false,
            filterable: false,
        },
        {
            datakey: 'recipient.username',
            name: intl.formatMessage({
                id: 'EAS_NOTIFICATIONS_COLUMN_RECIPIENT',
                defaultMessage: 'Příjemce',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'skipped',
            name: intl.formatMessage({
                id: 'EAS_NOTIFICATIONS_COLUMN_SKIPPED',
                defaultMessage: 'Přeskočená',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.BooleanCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'read',
            name: intl.formatMessage({
                id: 'EAS_NOTIFICATIONS_COLUMN_READ',
                defaultMessage: 'Přečtená',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.BooleanCell,
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=notification-columns.js.map